import React, { useEffect } from 'react';
import { KFLLayout } from '@kamstrup/kamstrup-frontend-library';
import { useSelector } from 'react-redux';
import TopHeader from '../layout/topheader';
import Menu from '../layout/menu';
import Sidebar from '../layout/sidebar';
import DevicesContent from './content';
import ActionsBar from './actionsBar';
import * as Devices from '../../modules/devices';
import { Groups } from '../../models';
import useUserEKS from '../../hooks/useUserEKS'
import { ReduxState } from '../../interfaces';

const DevicesPage: React.FC = () => {
  const { roles: userRoles } = useUserEKS();
  const { columns } = useSelector((s: ReduxState) => s.devicesState.table);

  useEffect(() => {
    if (columns.length === 0) Devices.updateColumnsByUser(userRoles || []);
  }, [columns, userRoles]);

  return (
    <KFLLayout
      topbar={<TopHeader />}
      content={<DevicesContent />}
      menu={
        <Menu title={Devices.msgTitle}>
          <ActionsBar />
        </Menu>
      }
      sidebar={<Sidebar selectedGroup={Groups.DEVICES} />}
    />
  );
};

export default DevicesPage;
